/**
 * BubblyUpdates Component Constants
 * Defines all constants used throughout the BubblyUpdates feature
 */

export const NEWS_UPDATES_CONSTANTS = {
  // Section titles
  EMPTY_STATE_MESSAGE: "You're all caught up! No updates to review today.",
  LATEST_TAG: 'Latest',
  PAGE_NAME: 'Ideas Bank',

  // Tailwind classes
  THUMBNAIL: {
    WIDTH: 'w-full md:w-[464px]',
    HEIGHT: 'h-[262px]',
    PADDING: 'p-4',
    ROUNDED: 'rounded-[16px]',
    BORDER: 'border-2 border-white',
    IMAGE_CLASSES: 'bg-cover bg-center bg-no-repeat object-cover',
  },
  // Responsive breakpoints
  BREAKPOINTS: {
    MOBILE: 'sm',
    TABLET: 'md',
    DESKTOP: 'lg',
  },
} as const
